







































































import {Component} from 'vue-property-decorator';
import CommonVue from '@/models/commonVue';

import ModulesIcon from '@/components/icons/ModulesIcon.vue';
import SkillsIcon from '@/components/icons/SkillsIcon.vue';
import TopicsIcon from '@/components/icons/TopicsIcon.vue';
import SyncIcon from '@/components/icons/SyncIcon.vue';
import CategoriesIcon from "@/components/icons/CategoriesIcon.vue";
import CourseIcon from '@/components/icons/TopicsIcon.vue';

@Component({
    components: {
        'modules-icon': ModulesIcon,
        'skills-icon': SkillsIcon,
        'topics-icon': TopicsIcon,
        'sync-icon': SyncIcon,
        'categories-icon': CategoriesIcon,
        'course-icon': CourseIcon,
    },
})
export default class HomeView extends CommonVue {

}
